module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp1_6000.3cefef6c.png";